import { useEffect } from "react";

function light() {
  const el = document.documentElement;
  el.style.setProperty("--bs-body-bg", "var(--bs-gray-100)");
  el.style.setProperty("--bs-body-color", "var(--bs-gray-900)");
  el.classList.add("light");
  el.classList.remove("dark");
}

export default function useSunCycleTheme() {
  useEffect(() => {
    light();
  }, []);
}
